<template>
  <NuxtImg
    v-if="badge"
    :alt="$t('myKiK')"
    src="/img/mykik.svg"
    width="47"
    :class="[
      'absolute z-10',
      getVerticalPosition(badge.verticalPosition),
      getHorizontalPosition(badge.horizontalPosition),
    ]"
  />
</template>

<script setup lang="ts">
defineProps<{
  badge?: {
    horizontalPosition: string;
    verticalPosition: string;
  };
}>();

const getVerticalPosition = (position?: string) => {
  switch (position) {
    case 'top':
      return 'top-4';
    case 'bottom':
      return 'bottom-4';
    default:
      return 'top-4';
  }
};

const getHorizontalPosition = (position?: string) => {
  switch (position) {
    case 'left':
      return 'left-4';
    case 'center':
      return 'left-1/2 -translate-x-1/2';
    case 'right':
      return 'right-4';
    default:
      return 'left-4';
  }
};
</script>
